// angular
// 	.module("HeroPRO")
// 	.controller("COReviewController", COReviewController);
import angular from 'angular';

import './coreview.scss';

/* @ngInject */
export default function COReviewController(
    $scope,
    EDocumentsFactory,
    $stateParams,
    AuthenticationFactory,
    $analytics,
    Timestamp,
    $q,
    $state,
    FRClosingFactory,
    FRInformationFactory,
    SelectedProductsFactory,
    DealTypeFactory,
    raSpinnerService,
    $uibModal
) {
    const vm = this;
    let p1;
    vm.appInfo = {};
    vm.products = {};
    vm.productSubtotal = 0;
    vm.financingTerm = 0;
    vm.interestAndFees = 0;
    vm.prePayment = 0;
    vm.projectTotal = 0;
    vm.productsLoaded = false;
    vm.selectedDealType = null;

    vm.approvingDocs = false;

    vm.approveDocs = () => {
        vm.approvingDocs = true;
        EDocumentsFactory.getDocusignLink($stateParams.appId, 'FinancingDocs')
        .then((response) => {            
            vm.approvingDocs = false;
            $state.go($state.$current, null, { reload: true });
        },
        (error) => {
            vm.approvingDocs = false;
        });
    };

    vm.init = () => {
    
        FRClosingFactory.getFundingRequestClosingPromise().then(() => {
            vm.selectedDealType = DealTypeFactory.getSelectedDealType();

            vm.fundingRequestDetail = FRClosingFactory.getFundingRequest().FundingRequestDetail;

            // only load the products if it's a purchase deal
            if (vm.fundingRequestDetail.FundingDisbursementModelTypeId && vm.fundingRequestDetail.FundingDisbursementModelTypeId !== 40 && vm.fundingRequestDetail.FundingDisbursementModelTypeId !== 50) {
                vm.loadProducts();
            }
        });
    };

    vm.loadProducts = () => {
        FRInformationFactory.getFundingRequestInformationPromise().then(() => {
            vm.appInfo = FRInformationFactory.getAppInfo();

            SelectedProductsFactory.getAddedProducts({ FundingRequestId: vm.appInfo.FundingRequestId }, true).then(() => {
                vm.products = angular.copy(SelectedProductsFactory.getSelectedProducts());
                if (vm.products.length > 0) {
                    vm.productSubtotal = SelectedProductsFactory.getProductSubtotal();
                    vm.financingTerm = SelectedProductsFactory.getFinancingTerm();
                    SelectedProductsFactory.getInterestAndFees(vm.appInfo).then((response) => {
                        vm.interestAndFees = response;
                        if (vm.appInfo.ClosingPrepayCAPI !== undefined && vm.appInfo.ClosingPrepayCAPI === true) {
                            vm.prePayment += vm.interestAndFees.CAPI || vm.interestAndFees.CAPIPrepay;
                        }
                        if (vm.appInfo.ClosingPrepayFees !== undefined && vm.appInfo.ClosingPrepayFees === true) {
                            vm.prePayment += vm.interestAndFees.ClosingCosts || vm.interestAndFees.ClosingCostsPrepay;
                        }
                        vm.projectTotal = SelectedProductsFactory.getProjectTotal();// - vm.prePayment;
                        vm.productsLoaded = true;
                    });
                }
            });
        });
    };

    vm.init();
}



// WEBPACK FOOTER //
// ./src/app/appDetail/walkthrough/startWork/CO-Review/COReviewController.js